<template>
	<el-drawer title="发放优惠券" :visible.sync="visible" :wrapperClosable="false" :size="450" @closed="closed">
		<div class="drawer-content">
			<el-form :model="formData" :rules="rules" ref="formData" label-position="top">
				<el-form-item label="待发放优惠券:">
					<span>{{ name }}</span>
				</el-form-item>
				<el-form-item prop="type" label="发放方式:">
					<el-radio v-model="formData.type" :label="1">用户ID发放</el-radio>
					<el-radio v-model="formData.type" :label="2">手机号发放</el-radio>
				</el-form-item>
				<el-form-item prop="sendType" label="发放对象:">
					<el-radio v-model="sendType" :label="1">手动输入</el-radio>
					<el-radio v-model="sendType" :label="2">上传Excel</el-radio>
				</el-form-item>
				<el-form-item prop="content" v-if="sendType == 1">
					<el-input type="textarea" v-model="formData.content" placeholder="请填写" size="medium"
						:maxlength="100000"></el-input>
				</el-form-item>
				<el-form-item prop="fileUrl" v-if="sendType == 2">
					<el-upload ref="uploadFile" drag action :http-request="upload" :file-list="fileList"
						:on-remove="onUploadRemove" :disabled="uploadLoading" accept=".xls, .xlsx" :limit="1"
						:on-exceed="handleExceed">
						<i class="el-icon-upload"></i>
						<div class="el-upload__text">将文件拖到此处，或<em>点击选择文件</em></div>
					</el-upload>
				</el-form-item>
				<div class="from-tip">
					<p class="MT10"><span class="el-icon-warning"></span> 选择【通过用户ID发放】则只能填写ID</p>
					<p class="MT10"><span class="el-icon-warning"></span> 选择【通过手机号发放】则只能填写大陆11位手机号</p>
					<p class="MT10"><span class="el-icon-warning"></span> 每个ID或者手机号单独一行，不需要首行表头</p>
					<p class="MT10"><span class="el-icon-warning"></span> 错误的ID或者手机号会自动跳过</p>
				</div>
			</el-form>
		</div>
		<div class="drawer-footer">
			<el-button @click="visible = false">取消</el-button>
			<el-button type="primary" @click="submitForm()" :loading="submitLoading"> 提交</el-button>
		</div>
	</el-drawer>
</template>

<script>
	import {
		uploadFileTmp
	} from '@/assets/js/commonApi.js';
	export default {
		data() {
			this.defaultFormData = {
				id: '',
				type: 1, //发放方式，1：通过用户ID发放 2：通过手机号发放 
				content: null,
				fileUrl: '',
			}

			// 验证使用范围
			const validateContent = (rule, value, callback) => {
				if (value && !/^[,，0-9]+$/.test(value)) {
					callback(new Error('请填写有效的ID或者手机号'));
				} else {
					callback();
				}
			};

			return {
				visible: false,
				formData: {
					...this.defaultFormData
				},
				name: null,
				rules: {
					type: {
						required: true,
						message: "请选择发放方式",
						trigger: 'change'
					},
					content: [{
							required: true,
							message: "请填写ID或手机号",
							trigger: 'change'
						},
						{
							validator: validateContent,
							trigger: 'change'
						}
					],
				},
				submitLoading: false,
				sendType: 1,
				uploadLoading: false,
				canSubmit: true,
				fileList: []
			};
		},
		mounted() {},
		methods: {
			show(data) {
				const {
					id,
					name
				} = data || {};
				this.name = name;
				this.visible = true;
				this.formData.id = id
			},
			closed() {
				this.formData = {
					...this.defaultFormData
				};
				this.submitLoading = false
				this.$nextTick(() => {
					this.$refs['formData'].clearValidate();
				});
				this.sendType = 1
			},
			handleExceed(files, fileList) {
				this.$message.warning('只允许上传一个文件');
			},
			async upload({
				file
			}) {
				const type = this.$utils.getFileType(file.name);

				if (type !== 'xls' && type !== 'xlsx') {
					this.$message.error('仅支持xls、xlsx文件格式,请重新选择上传文件!');
					return Promise.reject();
				}

				this.uploadLoading = true;

				const formData = new FormData();
				formData.append('file', file);

				const res = await uploadFileTmp(formData).catch(() => {
					return {
						data: {
							state: '0',
							msg: '请求错误'
						}
					};
				}).finally(() => {
					this.uploadLoading = false;
				});

				const {
					state,
					msg,
					result
				} = res.data;

				if (state !== '1') {
					this.$message.error(msg || '请求失败');
					return Promise.reject();
				}

				const path = result.url;
				this.formData.fileUrl = path
				//return await this.setUpload(path);
			},
			onUploadRemove() {
				this.formData.fileUrl = ''
			},
			// 表单提交
			submitForm() {
				if (this.sendType == 2 && this.formData.fileUrl == '') {
					return this.$message.error('请先上传文件！');
				}
				this.$refs["formData"].validate(async (valid) => {
					if (!valid) {
						return;
					}
					this.submitLoading = true;
					var contentString = this.formData.content ? this.formData.content.replace(/，/g, ',') :
					null;
					const res = await this.$request({
						url: '/coupon/send',
						method: 'post',
						data: {
							...this.formData,
							content: contentString,
						}
					}).catch(() => {
						return {
							data: {
								state: '0',
								msg: '请求错误'
							}
						};
					}).finally(() => {
						this.submitLoading = false;
					});

					const {
						state,
						msg
					} = res.data;

					if (state !== '1') {
						this.$message.error(msg || '请求失败');
						return;
					}

					this.$emit('submitSuccess');
					this.visible = false;
				});
			}
		}
	};
</script>